import axios from 'axios';

export const ReportsPageApi = {
  loadEmailList: filter =>
    axios.get(`/api/public/reports/email?filter=${filter}`),
  deleteEmail: data => axios.delete(`/api/public/reports/email/${data.email}`),
  addEmail: ( email) =>
    axios.post(`/api/public/reports/email?email=${email}`),
  loadReportFincenterActs: ((serviceProviderId, year) => axios.get(`/api/public/info/fincenter/acts/${serviceProviderId}?year=${year}`)),
  exportFincenterAct: (documentId) =>
    axios.get(`api:fileStore/public/directory/1/document/${documentId}/file?documentVersion=1&action=download`, {
      responseType: 'blob',
    }),
  viewFincenterAct: (documentId) =>
    axios.get(`api:fileStore/public/directory/1/document/${documentId}/file?documentVersion=1&action=view`, {
      responseType: 'blob'
    }),
  loadFincenterActById: id =>
    axios.get(`/api/public/info/fincenter/act/${id}`),
  generateFincenterAct: serviceProviderId =>
    axios.post(`/api/public/fincenter/act/generate/${serviceProviderId}`),


};